/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityRelationship } from './EntityRelationship';
import {
    EntityRelationshipFromJSON,
    EntityRelationshipFromJSONTyped,
    EntityRelationshipToJSON,
    EntityRelationshipToJSONTyped,
} from './EntityRelationship';

/**
 * 
 * @export
 * @interface RelationshipResponse
 */
export interface RelationshipResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipResponse
     */
    success?: boolean;
    /**
     * 
     * @type {EntityRelationship}
     * @memberof RelationshipResponse
     */
    relationship?: EntityRelationship;
}

/**
 * Check if a given object implements the RelationshipResponse interface.
 */
export function instanceOfRelationshipResponse(value: object): value is RelationshipResponse {
    return true;
}

export function RelationshipResponseFromJSON(json: any): RelationshipResponse {
    return RelationshipResponseFromJSONTyped(json, false);
}

export function RelationshipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelationshipResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'relationship': json['relationship'] == null ? undefined : EntityRelationshipFromJSON(json['relationship']),
    };
}

export function RelationshipResponseToJSON(json: any): RelationshipResponse {
    return RelationshipResponseToJSONTyped(json, false);
}

export function RelationshipResponseToJSONTyped(value?: RelationshipResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'relationship': EntityRelationshipToJSON(value['relationship']),
    };
}

